<script setup lang="ts">
    /**
     * @deprecated use IntroWidget.vue
     */

    const props = defineProps<IWidgetProps<ContentHeaderData>>();
    const { cmsComponentProps } = useWidget(props);
</script>
<template>
    <mol-intro v-bind="cmsComponentProps" />
</template>
